/**
 * Navegação por âncoras internas — partilhado pelo site (Next.js Link) e SPA.
 */

export interface AnchorLocation {
  pathname: string;
  origin: string;
}

/**
 * Devolve o hash (#secção) se `href` aponta para a mesma origem e, opcionalmente,
 * a mesma página. `null` se não for âncora interna acionável aqui.
 */
export function parseSamePageAnchor(
  href: string,
  loc: AnchorLocation,
): string | null {
  if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return null;
  let url: URL;
  try {
    url = new URL(href, `${loc.origin}${loc.pathname}`);
  } catch {
    return null;
  }
  if (url.origin !== loc.origin) return null;
  if (!url.hash || url.hash === '#') return null;
  if (url.pathname !== loc.pathname) return null;
  return url.hash;
}

/** Hash de link para a home (ex.: /#como-funciona) a partir de qualquer rota. */
export function parseHomeAnchor(href: string, origin: string): string | null {
  if (!href.includes('#')) return null;
  let url: URL;
  try {
    url = new URL(href, origin);
  } catch {
    return null;
  }
  if (url.origin !== origin) return null;
  if (url.pathname !== '/') return null;
  if (!url.hash || url.hash === '#') return null;
  return url.hash;
}

export function shouldHandleAnchorClick(event: MouseEvent): boolean {
  if (event.defaultPrevented) return false;
  if (event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  return true;
}
